import { observer } from 'mobx-react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Grid } from '@mui/material';
import Modal, { IModalProps } from 'components/Modal';
import GrowTransition from 'components/Modal/animations/grow';
import { Form, Formik } from 'formik';
import useNotification from 'hooks/useNotification';
import changePasswordModalValidation from 'modules/Profile/utils/modalValidation';
import store from 'store';

import TextField from '@common/components/Form/TextField';

interface PropsType extends Omit<IModalProps, 'title'> {}

function ChangePasswordModal({ onClose, ...props }: PropsType) {
	const { t } = useTranslation();
	const showNotification = useNotification();

	return (
		<Modal
			PaperProps={{
				sx: {
					maxWidth: '500px',
				},
			}}
			title={t('profile.changePassword')}
			TransitionComponent={GrowTransition}
			transitionDuration={500}
			onClose={onClose}
			{...props}
		>
			<Formik
				onSubmit={async (data, { setErrors }) => {
					try {
						console.info('data', data);
						await store.profile.changeUserPassword(data);

						showNotification('success', t('profile.changePasswordNotification'));
						onClose();
					} catch (e) {
						setErrors(e.errors);
						console.error('e', e);
					}
				}}
				initialValues={{
					old_password: '',
					password: '',
					password_confirmation: '',
				}}
				validationSchema={changePasswordModalValidation()}
			>
				<Form>
					<Grid container gap="16px" direction="column">
						<TextField
							name="old_password"
							placeholder={t('profile.currentPasswordPlaceholder')}
							type="password"
						/>
						<TextField
							name="password"
							placeholder={t('profile.newPasswordPlaceholder')}
							type="password"
						/>
						<TextField
							name="password_confirmation"
							placeholder={t('profile.repeatNewPasswordPlaceholder')}
							type="password"
						/>
						<Button
							type="submit"
							variant="contained"
							fullWidth
							sx={{ borderRadius: '10px' }}
							disabled={store.profile.loading}
						>
							{t('shared.save')}
						</Button>
					</Grid>
				</Form>
			</Formik>
		</Modal>
	);
}

export default observer(ChangePasswordModal);
